import { GenericLazyString, gettext } from '@eventbrite/i18n';
export interface SearchParamsForUrl {
    slug?: string;
    dates?: string;
    tags?: string[];
    price?: string;
    q?: string;
}
interface SuggestedSearch {
    content: GenericLazyString;
    value: SearchParamsForUrl;
    id: string;
}

export const SUGGESTED_SEARCHES: SuggestedSearch[] = [
    {
        content: gettext('Today'),
        value: { dates: 'today' },
        id: 'today',
    },
    {
        content: gettext('This weekend'),
        value: { dates: 'this_weekend' },
        id: 'this_weekend',
    },
    {
        content: gettext('Music'),
        value: { tags: ['EventbriteCategory/103'] },
        id: 'music',
    },
    {
        content: gettext('Business'),
        value: { tags: ['EventbriteCategory/101'] },
        id: 'business',
    },
    {
        content: gettext('Food & Drink'),
        value: { tags: ['EventbriteCategory/110'] },
        id: 'food_and_drink',
    },
    {
        content: gettext('Health'),
        value: { tags: ['EventbriteCategory/107'] },
        id: 'health',
    },
    {
        content: gettext('Hobbies'),
        value: { tags: ['EventbriteCategory/119'] },
        id: 'hobbies',
    },
    {
        content: gettext('Performing & Visual Arts'),
        value: { tags: ['EventbriteCategory/105'] },
        id: 'arts',
    },
];
